/**
 * Geometría PURA de entidades de polilínea (ancho / longitud). Sin estado de
 * componente, sin THREE. Extraída de LayoutBuilder para aislar negocio de la
 * presentación.
 */

/**
 * Ancho máximo de la polilínea: el `width` de la entidad o el mayor
 * startWidth/endWidth de sus vértices.
 * @param {Object} entity
 * @returns {number}
 */
export function getEntityMaxWidth(entity) {
  let w = (entity && entity.width) || 0
  const verts = (entity && entity.vertices) || []
  for (const v of verts) {
    if (v.startWidth) w = Math.max(w, v.startWidth)
    if (v.endWidth)   w = Math.max(w, v.endWidth)
  }
  return w
}

/**
 * Suma de longitudes de los segmentos de la polilínea.
 * @param {Object} entity
 * @returns {number}
 */
export function getEntityTotalLength(entity) {
  const verts = (entity && entity.vertices) || []
  let total = 0
  for (let i = 0; i < verts.length - 1; i++) {
    const dx = verts[i + 1].x - verts[i].x
    const dy = verts[i + 1].y - verts[i].y
    total += Math.sqrt(dx * dx + dy * dy)
  }
  return total
}
